<template>
  <div
    class="invite-container"
    :style="`background-image: url('${defaultBackground}')`"
  >
    <div class="header">
      <div class="back" @click="$router.back()"></div>
      <h1>邀请好友</h1>
    </div>
    <div class="content">
      <a
        :href="`http://qr.topscan.com/api.php?text=${shareUrl}`"
        download="w3logo"
      >
        <img :src="`http://qr.topscan.com/api.php?text=${shareUrl}`" alt="" />
      </a>
      <p>保存二维码或复制链接发送给好友邀请</p>
    </div>
    <div class="send">
      <button v-if="shareUrl" v-copy="shareUrl" class="copy-link-button">
        复制推广链接
      </button>
      <ml-button :is-theme-color="true">保存二维码</ml-button>
    </div>
  </div>
</template>

<script>
import defaultBackground from "@/assets/vip/invite_bg@2x.png";
import { mapState } from "vuex";
import toast from "@/utils/toast";

export default {
  name: "Invite",
  directives: {
    copy: {
      handleClipboard: null,
      bind(el, binding) {
        binding.def.handleClipboard = function() {
          const inputElement = document.createElement("input");
          inputElement.setAttribute("value", binding.value);
          document.body.appendChild(inputElement);
          inputElement.select();
          document.execCommand("copy");
          toast("已复制推广链接，快去分享给朋友吧");
          document.body.removeChild(inputElement);
        };
        el.addEventListener("click", binding.def.handleClipboard);
      },
      unbind(el, binding) {
        el.removeEventListener("click", binding.def.handleClipboard);
      }
    }
  },
  computed: {
    ...mapState("user", ["id"]),
    shareUrl() {
      return `${process.env.VUE_APP_DOMAIN}/share?code=${this.id}`;
    }
  },
  data() {
    return {
      defaultBackground
    };
  }
};
</script>

<style lang="scss" scoped>
.invite-container {
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  .header {
    .back {
      position: absolute;
      left: 0;
      width: 40px;
      height: 40px;
      background-image: url("../../assets/vip/back@2x.png");
      background-size: 9px 14px;
      background-position: center;
      background-repeat: no-repeat;
    }
    h1 {
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      line-height: 40px;
    }
  }
  .content {
    margin: 50px auto;
    padding: 40px;
    width: 245px;
    height: 314px;
    background: rgba(253, 215, 0, 1);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    img {
      width: 170px;
      height: 170px;
    }
    p {
      margin-top: 30px;
      font-size: 15px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 21px;
    }
  }
  .send {
    padding-bottom: 30px;
    display: flex;
    justify-content: center;
    .copy-link-button {
      margin-right: 20px;
      width: 150px;
      height: 42px;
      line-height: 42px;
      background: rgba(0, 0, 0, 0.12);
      border-radius: 21px;
      border: 1px solid rgba(255, 255, 255, 1);
      font-size: 15px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
    .save-qr-code {
      width: 150px;
      height: 42px;
      line-height: 42px;
      background: rgba(253, 215, 0, 1);
      border-radius: 21px;
      font-size: 15px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }
  }
}
</style>
